<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="reportCode" label="报告编号">
        <el-input
          v-model="searchModel.reportCode"
          placeholder="输入报告编号"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="client" label="委托单位">
        <el-input
          v-model.trim="searchModel.client"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sampleName" label="检测项目">
        <el-input
          v-model="searchModel.sampleName"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="orderType" label="排序规则">
        <el-select v-model="searchModel.orderType" placeholder="请选择" clearable @change="getTableData(true)">
          <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="text" class="search-isOpen" @click="collapsed = !collapsed">
          {{ collapsed ? '展开' : '收起' }}
          <i class="el-icon--right" :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_reportAudit" @onRefresh="getTableData()">
        <el-radio-group v-model="searchModel.state" @change="handleDeliverState">
          <el-radio-button label="7">待审核</el-radio-button>
          <el-radio-button label="-8,9,10">已审核</el-radio-button>
        </el-radio-group>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报告编号" width="140" align="center" fixed>
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleProcess(row)">{{ row.reportCode }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="client" label="委托单位" min-width="140" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="检测项目" min-width="140" align="center"></el-table-column>
        <el-table-column label="审核状态" :showOverflowTooltip="false" width="130" align="center">
          <template v-slot="{ row }">
            <el-tag v-if="searchModel.state != 7" :type="row.state == -8 ? 'danger' : 'success'">
              {{ row.state == '-8' ? '审核驳回' : '审核通过' }}
            </el-tag>
            <el-tag v-else type="info">待审核</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="syrName" label="编制人" align="center" width="120"></el-table-column>
        <el-table-column label="操作" width="100" :showOverflowTooltip="false" align="center" fixed="right">
          <template v-if="searchModel.state == 7" v-slot="{ row }">
            <el-link type="primary" @click="handleAudit(row)">审核</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
    <!-- 审核弹窗 -->
    <AuditDialog
      :visible.sync="auditVisible"
      auditType="reportAudit"
      :auditTitle="auditTitle"
      :auditId="activeRowId"
      :auditLoading="auditLoading"
      api="editFlowState"
      @refreshData="getTableData()"
    >
      <div v-loading="auditLoading" class="audit-container">
        <el-button v-if="hasQlf" type="primary" @click="previewReport(0)">检测报告(合格)</el-button>
        <el-button v-if="hasUnqlf" type="danger" @click="previewReport(1)">检测报告(不合格)</el-button>

        <div class="table-wrap">
          <table v-if="flowImgList.length > 0" class="word-table">
            <tr>
              <td width="20%">
                <span class="label">图片附件</span>
              </td>
              <td>
                <div class="img-list">
                  <el-image
                    v-for="(url, imgIndex) in flowImgList"
                    :key="imgIndex"
                    style="width: 44px; height: 44px"
                    :src="url"
                    :preview-src-list="flowImgList"
                  ></el-image>
                </div>
              </td>
            </tr>
          </table>
          <EntrustTable :detailData="auditEntrustData" />
        </div>
      </div>
    </AuditDialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';

import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';
import AuditDialog from '@/components/BusinessComponents/AuditDialog';
import EntrustTable from '@/components/BusinessComponents/EntrustTable';

import { getEntrustmentSet } from '@/api/entrust';
import { getAuditList, getFlowInfo } from '@/api/flow';
import { getEntrustment } from '@/api/entrust';

export default {
  components: { TableHeader, ProcessDialog, AuditDialog, EntrustTable },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        reportCode: '',
        client: '',
        sampleName: '',
        itemName: null,
        orderType: 2,
        state: '7',
        dateRange: []
      },
      orderTypeOptions: [
        {
          value: 2,
          label: '编号降序'
        },
        {
          value: 3,
          label: '编号升序'
        },
        {
          value: 0,
          label: '创建时间降序'
        },
        {
          value: 1,
          label: '创建时间升序'
        }
      ],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      activeRowInfo: {},
      processVisible: false,
      auditTitle: '报告审核',
      auditVisible: false,
      hasQlf: false, // 是否有合格样品
      hasUnqlf: false, // 是否有不合格样品
      reqSign: 0,
      auditEntrustData: {},
      flowImgList: [],
      pageOffcieCanCallback: true,
      auditLoading: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async handleDeliverState() {
      await this.getTableData(true);
      this.$nextTick(() => {
        this.$refs.table.doLayout(); // 重置表格布局
      });
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getAuditList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      const tableData = data.list || [];
      this.tableData = tableData.map(item => {
        const basis = JSON.parse(item.basisJson);
        const testItem = basis.map(item => item.itemName);
        // 去重
        const uniqueTestItem = [...new Set(testItem)];

        item.testItemList = uniqueTestItem;
        item.basisList = basis || [];

        return item;
      });

      this.tableLoading = false;
    },
    handleAudit(row) {
      this.auditTitle = `报告审核【${row.reportCode}】`;
      this.activeRowId = row.entrustmentId;
      this.getEntrustData(row.entrustmentId);
      this.auditVisible = true;
    },
    async getEntrustData(id) {
      this.auditLoading = true;

      try {
        const { data } = await getEntrustment({ id });
        const { data: flowData } = await getFlowInfo({ entrustmentId: id });
        this.hasQlf = flowData?.flow?.reqState > 0 ? true : false; // 合格报告
        this.hasUnqlf = flowData?.flow?.reqState1 > 0 ? true : false; // 不合格报告
        this.reqSign = flowData?.flow?.reqSign || 0;
        const imgPath = flowData?.flow?.imgPath || null;

        if (imgPath) {
          this.flowImgList = imgPath.split(',').map(item => {
            return this.$imgUrl + item;
          });
        } else {
          this.flowImgList = [];
        }

        data.sampleInfoList.forEach(item => {
          if (item.imgs) {
            if (this.isJSONObjectOrArray(item.imgs)) {
              const allFiles = JSON.parse(item.imgs);
              item.imgs = allFiles.imgs;

              if (allFiles.imgs) {
                item.imgList = allFiles.imgs.split(',').map(item => {
                  return this.$imgUrl + item;
                });
              }
              item.files = allFiles?.files || [];
            } else {
              item.imgs = item.imgs;
              item.imgList = item.imgs.split(',').map(item => {
                return this.$imgUrl + item;
              });
              item.files = [];
            }
          } else {
            item.imgs = '';
            item.imgList = [];
            item.files = [];
          }
        });

        const { data: entrustmentSetData } = await getEntrustmentSet({ id: data.mainId });
        if (entrustmentSetData.entrustmentUserList) {
          data.entrustmentUsers = entrustmentSetData.entrustmentUserList.map(item => item.userName).join(',');
        } else {
          data.entrustmentUsers = '';
        }
        this.auditEntrustData = data;
      } finally {
        this.auditLoading = false;
      }
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    previewReport(ft) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: this.reqSign < 2 ? 'auditReport' : 'report',
        entrustmentId: this.auditEntrustData.id,
        ft
      });
      if (ft == 0) {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
      } else {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/reportFail', 'width=1200px;height=800px;', params);
      }
    },
    handleProcess(row) {
      this.activeRowId = row.mainId;
      this.processVisible = true;
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.audit-container {
  height: 100%;

  .table-wrap {
    height: calc(100% - 42px);
    margin-top: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
